var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.xMentionBox)?_c('div',[(_setup.isUsingMediaComments())?[(
        _setup.isSmallerThanTabletPortrait && _setup.activeDraftCid // editing on mobile post composer
      )?_c(_setup.MentionAutocompleteBar):_c(_setup.MentionAutocompletePopover)]:[(_setup.isSmallerThanTabletPortrait && !(_setup.expandedPostCid && !_setup.hasCommentBeingEdited))?_c(_setup.MentionAutocompleteBar):_c(_setup.MentionAutocompletePopover)]],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }